import { createTheme, ThemeProvider } from "@mui/material";
import "bootstrap/dist/css/bootstrap.css";
import { createRoot } from "react-dom/client";
import TagManager from "react-gtm-module";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import App from "./App";
import "./index.scss";
import * as serviceWorker from "./serviceWorker";
import { reducers } from "./store/reducer";

//Pollyfill for Object entries IN IE11
if (!Object.entries) {
  Object.entries = function (obj) {
    const ownProps = Object.keys(obj);
    let i = ownProps.length;
    const resArray = new Array(i); // preallocate the Array
    while (i--) resArray[i] = [ownProps[i], obj[ownProps[i]]];

    return resArray;
  };
}
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_TAGMANAGER,
};
TagManager.initialize(tagManagerArgs);


const store = createStore(reducers, composeWithDevTools());

const theme = createTheme({
  typography: {
    fontFamily: "'Titillium Web', sans-serif",
  },
  palette: {
    primary: { main: "#DB0F0F" },
    secondary: { main: "#576D7C" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          color: "#fff",
        },
      },
    },
  },
});

const container = document.getElementById("root");
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </Provider>
);

serviceWorker.unregister();
